import {
  ApptTelemedTab,
  DispositionType,
  PractitionerQualificationCode,
  RoleType,
  TelemedAppointmentVisitTabs,
} from 'utils';

export const dataTestIds = {
  closeIcon: 'CloseIcon',
  loadingSpinner: 'loading-spinner',
  loadingScreen: 'loading-screen',
  deleteOutlinedIcon: 'DeleteOutlinedIcon',
  header: {
    userName: 'header-user-name',
  },
  inPersonHeader: {
    container: 'in-person-header-container',
    patientName: 'patient-name',
    appointmentStatus: 'appointment-status',
    switchModeButton: (status: string) => `switch-status-to-${status}`,
    intakePractitionerInput: 'intake-practitioner-input',
    providerPractitionerInput: 'provider-practitioner-input',
    changeStatusDropdown: 'change-status-dropdown-in-header',
    allergies: 'header-allergies',
    weight: 'header-weight',
  },
  dashboard: {
    appointmentsTable: (tab: 'prebooked' | 'in-office' | 'completed' | 'cancelled') => `appointments-table-${tab}`,
    addPatientButton: 'add-patient-button',
    approveButton: 'approve-button',
    intakeButton: `intake-button`,
    visitDetailsButton: `visit-details-button`,
    progressNoteButton: `progress-note-button`,
    dischargeButton: 'discharge-button',
    prebookedTab: 'prebooked-tab',
    locationSelect: 'location-select',
    datePickerTodayButton: 'date-picker-today-button',
    loadingIndicator: 'loading-indicator',
    tableRowWrapper: (appointmentId: string) => `appointments-table-row-${appointmentId}`,
    tableRowStatus: (appointmentId: string) => `appointments-table-row-status-${appointmentId}`,
    inOfficeTab: 'in-office-tab',
    groupSelect: 'group-select',
    dischargedTab: 'discharged-tab',
    cancelledTab: 'cancelled-tab',
    arrivedButton: 'arrived-button',
    appointmentStatus: 'appointment-status',
    chatButton: 'Chat-outlined-icon',
    patientName: 'patient-name',
  },
  appointmentPage: {
    patientFullName: 'patient-full-name',
    changeStatusDropdown: 'change-status-dropdown-in-appointment-page',
  },
  addPatientPage: {
    pageTitle: 'page-title',
    mobilePhoneInput: 'mobile-phone-input',
    searchForPatientsButton: 'search-for-patients-button',
    addButton: 'add-button',
    cancelButton: 'cancel-button',
    patientNotFoundButton: 'patient-not-found-button',
    firstNameInput: 'first-name-input',
    lastNameInput: 'last-name-input',
    sexAtBirthDropdown: 'sex-at-birth-dropdown',
    reasonForVisitDropdown: 'reason-for-visit-dropdown',
    visitTypeDropdown: 'visit-type-dropdown',
    serviceCategoryDropdown: 'service-category-dropdown',
    dateFormatValidationError: 'date-format-validation-error',
    prefillForButton: 'prefill-for-button',
    prefilledPatientName: 'prefilled-patient-name',
    prefilledPatientBirthday: 'prefilled-patient-birthday',
    prefilledPatientBirthSex: 'prefilled-patient-birth-sex',
    prefilledPatientEmail: 'prefilled-patient-email',
  },
  pagination: {
    paginationContainer: 'pagination-container',
  },
  patientInformationPage: {
    saveChangesButton: 'save-changes-button',
    addInsuranceButton: 'add-insurance-button',
    breadcrumb: 'breadcrumb',
    pharmacySearch: 'pharmacy-search',
    pharmacySearchDisplay: { text: 'pharmacy-search-display', button: 'pharmacy-search-display-reset-btn' },
  },
  patientHeader: {
    patientId: 'header-patient-id',
    patientName: 'header-patient-name',
    patientBirthSex: 'header-patient-birth-sex',
    patientBirthday: 'header-patient-birthday',
    patientAddress: 'header-patient-address',
    patientPhoneNumber: 'header-patient-phone-number',
    emergencyContact: 'header-patient-emergency-contact',
    closeButton: 'header-patient-close-button',
  },
  insuranceContainer: {
    showMoreButton: 'insurance-show-more-button',
    removeButton: 'insurance-remove-button',
  },
  userSettingsContainer: {
    releaseOfInfoDropdown: 'release-of-info-dropdown',
    RxHistoryConsentDropdown: 'Rx-history-consent-dropdown',
  },

  slots: {
    slot: 'slot',
  },
  dialog: {
    closeButton: 'dialog-close-button',
    cancelButton: 'dialog-cancel-button',
    proceedButton: 'dialog-proceed-button',
    title: 'dialog-title',
    message: 'dialog-message',
    inPersonModalContent: 'in-person-modal-content',
    alertIcon: 'WarningAmberOutlinedIcon',
  },
  virtualLocationsPage: {
    locationsSearch: 'locations-search',
    locationValue: 'location-value',
    operateInLocationValue: 'operate-in-location-value',
    locationRow: (locationId: string) => `location-row-${locationId}`,
  },
  editVirtualLocation: {
    saveChangesButton: 'save-changes-button',
    cancelButton: 'cancel-button',
    operateInLocationToggle: 'operate-in-location-toggle',
    locationNameTitle: 'location-name-title',
    locationNameField: 'location-name-field',
    locationStateField: 'location-state-field',
  },
  patients: {
    searchByLastNameField: 'search-last-name-field',
    searchByGivenNamesField: 'search-given-names-field',
    searchByDateOfBirthField: 'searchByDateOfBirthField',
    searchByPidField: 'search-pid-field',
    searchByPhoneField: 'search-phone-field',
    searchByAddressField: 'search-by-address',
    searchByEmailField: 'search-by-email-field',
    searchByStatusName: 'search-by-status-name',
    searchByLocationName: 'search-by-location-name',
    searchButton: 'search-button',
    resetFiltersButton: 'reset-filters-button',
    patientId: 'patient-id',
    patientName: 'patient-name',
    patientDateOfBirth: 'patient-date-of-birth',
    patientEmail: 'patient-email',
    patientPhoneNumber: 'patient-phone-number',
    patientAddress: 'patient-address',
    searchResultsRowPrefix: 'search-result-row-',
    searchResultRow: (patientId: string) => `${dataTestIds.patients.searchResultsRowPrefix}${patientId}`,
  },
  employeesPage: {
    table: 'employees-providers-content-table',
    providersTabButton: 'providers-tab-button',
    searchByName: 'search-by-name-field',
    providersStateFilter: 'providers-state-filter',
    informationForm: 'employee-information-form',
    firstName: 'employee-first-name',
    middleName: 'employee-middle-name',
    lastName: 'employee-last-name',
    birthDate: 'employee-birth-date',
    email: 'employee-email',
    phone: 'employee-phone',
    fax: 'employee-fax',
    addressLine1: 'employee-address-line-1',
    addressLine2: 'employee-address-line-2',
    addressCity: 'employee-address-city',
    addressState: 'employee-address-state',
    addressZip: 'employee-address-zip',
    rolesSection: 'employee-roles-section',
    roleRow: (employeeRole: RoleType): string => `employee-${employeeRole}-role`,
    providerDetailsProviderTypeDropdown: 'employees-provider-details-provider-type-dropdown',
    providerDetailsProviderTypeOtherText: 'employees-provider-details-provider-type',
    providerDetailsNPI: 'employees-provider-details-npi',
    submitButton: 'employees-form-submit-button',
    qualificationsTable: 'employee-qualifications-table',
    qualificationRow: (code: PractitionerQualificationCode): string => `employee-${code}-qualification`,
    deleteQualificationButton: 'employee-delete-qualification-button',
    addQualificationCard: 'add-new-qualification-card',
    newQualificationStateDropdown: 'new-qualification-state-dropdown',
    newQualificationTypeDropdown: 'new-qualification-type-dropdown',
    newQualificationNumberField: 'new-qualification-number-field',
    newQualificationExpDatePicker: 'new-qualification-expiration-date-picker',
    addQualificationButton: 'add-qualification-button',
    deactivateUserButton: 'deactivate-user-button',
    statusChip: 'employee-status-chip',
    needsReviewChip: 'employee-needs-review-chip',
    assignRoleButton: 'employee-assign-role-button',
    assignRoleDialog: 'employee-assign-role-dialog',
    assignRoleSelect: 'employee-assign-role-select',
    assignRoleSave: 'employee-assign-role-save',
    quickDeleteButton: 'employee-quick-delete-button',
  },
  telemedEhrFlow: {
    trackingBoardLocationsSelect: 'telemed-tracking-board-location-select',
    trackingBoardLocationsSelectOption: (id: string) => `telemed-tracking-board-location-select-option-${id}`,
    telemedAppointmentsTabs: (tab: ApptTelemedTab) => `telemed-appointments-tabs-${tab}`,
    trackingBoardTableGroupRow: `telemed-tracking-board-table-group-row`,
    trackingBoardTableRow: (appointmentId: string) => `telemed-tracking-board-table-row-${appointmentId}`,
    myPatientsButton: 'telemed-my-patients-button',
    allPatientsButton: 'telemed-all-patients-button',
    trackingBoardTable: 'telemed-tracking-board-table',
    trackingBoardAssignButton: 'telemed-tracking-board-assign-appointment-button',
    trackingBoardViewButton: (appointmentId?: string) =>
      `telemed-tracking-board-view-appointment-button-${appointmentId}`,
    trackingBoardChatButton: (appointmentId?: string) =>
      `telemed-tracking-board-chat-appointment-button-${appointmentId}`,
    appointmentStatusChip: 'telemed-appointment-status-chip',
    footerButtonConnectToPatient: 'telemed-appointment-footer-button-connect-to-patient',
    footerButtonAssignMe: 'telemed-appointment-footer-button-assign-me',
    footerButtonUnassign: 'telemed-appointment-footer-button-unassign',
    appointmentChartFooter: 'telemed-chart-appointment-footer',
    hpiFieldListLoadingSkeleton: 'telemed-hpi-field-list-loading-skeleton',
    hpiCurrentMedicationsPatientProvidedList: 'telemed-hpi-current-medications-patient-provided-list',
    hpiCurrentMedicationsInput: 'telemed-hpi-current-medications-input',
    hpiCurrentMedicationsDoseInput: 'telemed-hpi-current-medications-dose-input',
    hpiCurrentMedicationsDateTimeInput: 'telemed-hpi-current-medications-date-time-input',
    hpiCurrentMedicationsAddButton: 'telemed-hpi-current-medications-add-button',
    hpiCurrentMedicationsScheduledList: 'telemed-hpi-current-medications-scheduled-list',
    hpiCurrentMedicationsAsNeededList: 'telemed-hpi-current-medications-as-needed-list',
    hpiCurrentMedicationsScheduledRadioButton: 'telemed-hpi-current-medications-scheduled-radio-button',
    hpiCurrentMedicationsAsNeededRadioButton: 'telemed-hpi-current-medications-as-needed-radio-button',
    hpiCurrentMedicationsList: (listType: 'scheduled' | 'as-needed') =>
      `telemed-hpi-current-medications-list-${listType}`,
    hpiCurrentMedicationsListItem: (listDataTestId: string) => `${listDataTestId}-item`,
    hpiCurrentMedicationsColumn: 'telemed-hpi-current-medications-column',
    hpiSurgicalHistoryColumn: 'telemed-hpi-surgical-history-column',
    hpiSurgicalHistoryPatientProvidedList: 'telemed-hpi-surgical-history-patient-provided-list',
    hpiAdditionalQuestions: (questionSymptom: string) => `telemed-additional-questions-${questionSymptom}`,
    hpiAdditionalQuestionsPatientProvided: (questionSymptom: string) =>
      `telemed-additional-questions-patient-provided-${questionSymptom}`,
    hpiSurgicalHistoryNote: 'telemed-hpi-surgical-history-note',
    hpiChiefComplaintNotes: 'telemed-chief-complaint-notes',
    hpiChiefComplaintRos: 'telemed-chief-complaint-ros',
    hpiPatientConditionPhotos: 'telemed-patient-condition-photos',
    hpiReasonForVisit: 'telemed-reason-for-visit',
    videoRoomContainer: 'telemed-video-room-container',
    endVideoCallButton: 'telemed-end-video-call-button',
    pinVideoCallButton: 'telemed-pin-video-call-button',
    finishVisitButton: 'telemed-finish-visit-button',
    appointmentVisitTabs: (tab: TelemedAppointmentVisitTabs) => `telemed-appointment-visit-tab-${tab}`,
    patientInfoConfirmationCheckbox: 'telemed-patient-info-confirmation-checkbox',
    signButton: 'telemed-sign-button',
    closeChartButton: 'telemed-chart-close-icon',
    planTabDispositionContainer: 'telemed-plan-tab-disposition-container',
    planTabDispositionToggleButton: (buttonName: DispositionType) =>
      `telemed-plan-tab-disposition-toggle-button-${buttonName}`,
    planTabDispositionFollowUpDropdown: 'telemed-plan-tab-disposition-follow-up-dropdown',
    planTabDispositionNote: 'telemed-plan-tab-disposition-note',
    planTabDispositionReasonForTransferDropdown: 'telemed-plan-tab-disposition-reason-for-transfer-dropdown',
    reviewTabMedicationsContainer: 'telemed-review-tab-medications-container',
    reviewTabAdditionalQuestion: (questionSymptom: string) =>
      `telemed-review-tab-additional-question-${questionSymptom}`,
    reviewTabChiefComplaintContainer: 'telemed-review-tab-chief-complaint-container',
    reviewTabRosContainer: 'telemed-review-tab-ros-container',
    reviewTabPatientInstructionsContainer: 'telemed-review-tab-patient-instructions-container',
    reviewTabExaminationsContainer: 'telemed-review-tab-examinations-container',
    examTabTable: 'telemed-exam-tab-table',
    cancelThisVisitButton: 'telemed-cancel-this-visit-button',
    inviteParticipant: 'telemed-invite-participant-button',
    editPatientButtonSideBar: 'telemed-edit-patient-button-side-bar',
    chatModalDescription: 'telemed-chat-modal-description',
    telemedNewOrExistingPatient: 'telemed-new-or-existing-patient',
    hpiSurgicalHistoryAddNoteButton: 'telemed-hpi-surgical-history-add-note-button',
    hpiSurgicalHistoryNoteIsLoading: 'telemed-hpi-surgical-history-note-is-loading',
    closeImagePreviewButton: 'close-image-preview-button',
  },
  sideMenu: {
    completeIntakeButton: 'complete-intake-button',
    sideMenuItem: (item: string): string => `menu-item-${item}`,
  },
  inPersonModal: {
    confirmationDialogue: 'confirmation-dialogue',
  },
  hospitalizationPage: {
    hospitalizationTitle: 'hospitalization-title',
    hospitalizationDropdown: 'hospitalization-dropdown',
    hospitalizationList: 'hospitalization-list',
    deleteIcon: 'DeleteOutlinedIcon',
    addNoteButton: 'add-hospitalization-note-button',
    pencilIconButton: 'EditOutlinedIcon',
  },
  progressNotePage: {
    reviewAndSignButton: 'review-and-sign-button',
    unlockAppointmentButton: 'unlock-appointment-button',
    dischargeButton: 'discharge-button',
    sendFaxButton: 'send-fax-button',
    dischargeSummaryButton: 'discharge-summary-button',
    missingCard: 'missing-card',
    missingCardText: 'missing-card-text',
    patientVerificationLink: 'patient-verification-link',
    primaryDiagnosisLink: 'primary-diagnosis-link',
    secondaryDiagnosisLink: 'secondary-diagnosis-link',
    medicalDecisionLink: 'medical-decision-link',
    emCodeLink: 'em-code-link',
    hpiLink: 'hpi-link',
    accidentDateLink: 'accident-date-link',
    ccLink: 'chief-complaint-link',
    visitNoteCard: 'visit-note-card',
    procedureItem: 'procedure-item',
    vaccineItem: 'vaccine-item',
    inHouseMedicationItem: 'in-house-medication-item',
    labsTitle: (labType: string) => `title-${labType.toLowerCase().replace(/\s+/g, '-')}`,
    knownAllergiesContainer: 'known-allergies-container',
    medicalConditionsContainer: 'medical-conditions-container',
    surgicalHistoryContainer: 'surgical-history-container',
    additionalQuestions: 'additional-questions',
    supervisorApprovalCheckbox: 'supervisor-approval-checkbox',
    hpiContainer: 'hpi-container',
    vitalsContainer: 'vitals-container',
    vitalsItem: 'vitals-item',
    hospitalizationContainer: 'hospitalization-container',
    alertIcon: 'WarningAmberOutlinedIcon',
    cptCodes: 'cpt-codes-container',
    rosReviewContainer: 'in-person-progress-note-ros-review-container',
  },
  hpiAndTemplatesPage: {
    hpiTitle: 'hpi-title',
    hpiNotes: 'hpi-notes',
  },
  assessmentCard: {
    emCodeDropdown: 'em-code-dropdown',
    medicalDecisionField: 'medical-decision-field',
    cptCodeField: 'cpt-code-field',
    medicalDecisionLoading: 'medical-decision-loading',
  },
  diagnosisContainer: {
    diagnosisDropdown: 'diagnosis-dropdown',
    allDiagnosesContainer: 'diagnosis-container-all-diagnoses',
    primaryDiagnosis: 'diagnosis-container-primary-diagnosis',
    secondaryDiagnosisContainer: 'diagnosis-container-secondary-diagnosis-container',
    secondaryDiagnosis: 'diagnosis-container-secondary-diagnosis',
    primaryDiagnosisDeleteButton: 'diagnosis-container-primary-diagnosis-delete-button',
    secondaryDiagnosisDeleteButton: 'diagnosis-container-secondary-diagnosis-delete-button',
    makePrimaryButton: 'diagnosis-container-make-primary-button',
  },
  billingContainer: {
    container: 'billing-container',
    deleteButton: 'billing-container-delete-button',
    deleteCptCodeButton: (code: string) => `billing-container-delete-cpt-code-button-${code}`,
    cptCodeEntry: (code: string) => `cpt-code-entry-${code}`,
    cptCodeContainer: 'additional-cpt-code-container',
  },
  patientInfoPage: {
    patientInfoVerifiedCheckbox: 'patient-info-verified-checkbox',
  },
  inHouseMedicationsPage: {
    title: 'medications-title',
    orderButton: 'order-button',
    marTableLoader: 'mar-table-loader',
    marTable: {
      medicationRowPrefix: 'mar-table-medication-row-',
      medicationRow: (medicationId: string) => `mar-table-medication-row-${medicationId}`,
      medicationCell: 'mar-table-medication-cell',
      statusCell: 'mar-table-status-cell',
      doseCell: 'mar-table-dose-cell',
      routeCell: 'mar-table-route-cell',
      orderedByCell: 'mar-table-ordered-by-cell',
      givenByCell: 'mar-table-given-by-cell',
      reasonCell: 'mar-table-reason-cell',
      instructionsCell: 'mar-table-instructions-cell',
    },
    medicationDetailsTab: 'medication-details-tab',
    marTab: 'mar-tab',
    pencilIconButton: 'EditOutlinedIcon',
    deleteButton: 'DeleteOutlinedIcon',
    administeredButton: 'administered-button',
    partlyAdministeredButton: 'partly-administered-button',
    notAdministeredButton: 'not-administered-button',
    medicationHistoryTableMedication: 'medication-history-table-medication',
    medicationHistoryTableType: 'medication-history-table-type',
    medicationHistoryTableWhoAdded: 'medication-history-table-who-added',
    medicationHistoryTableRow: 'medication-history-table-row',
  },
  orderMedicationPage: {
    inputField: (field: string): string => `input-${field}`,
    fillOrderToSaveButton: 'fill-order-to-save-button',
    backButton: 'back-button',
    confirmationDialogue: 'confirmation-dialogue',
  },
  vitalsPage: {
    title: 'vitals-title',
    deleteVitalModal: 'delete-vital-modal',
    addAllVitalsButton: 'vitals-page-add-all-button',
    temperatureInput: 'temperature-input',
    temperatureHeader: 'temperature-header',
    temperatureAddButton: 'temperature-add-button',
    temperatureItem: 'temperature-item',
    heartbeatHeader: 'heartbeat-header',
    heartbeatInput: 'heartbeat-input',
    heartbeatAddButton: 'heartbeat-add-button',
    heartbeatItem: 'heartbeat-item',
    respirationRateHeader: 'respiration-rate-header',
    respirationRateInput: 'respiration-rate-input',
    respirationRateAddButton: 'respiration-rate-add-button',
    respirationRateItem: 'respiration-rate-item',
    bloodPressureHeader: 'blood-pressure-header',
    bloodPressureSystolicInput: 'blood-pressure-systolic-input',
    bloodPressureDiastolicInput: 'blood-pressure-diastolic-input',
    bloodPressureAddButton: 'blood-pressure-add-button',
    bloodPressureItem: 'blood-pressure-item',
    oxygenSaturationHeader: 'oxygen-saturation-header',
    oxygenSaturationInput: 'oxygen-saturation-input',
    oxygenSaturationAddButton: 'oxygen-saturation-add-button',
    oxygenSaturationItem: 'oxygen-saturation-item',
    weightHeader: 'weight-header',
    weightInput: 'weight-input',
    weightPatientRefusedCheckbox: 'weight-patient-refused-checkbox',
    weightAddButton: 'weight-add-button',
    weightItem: 'weight-item',
    heightHeader: 'height-header',
    heightInput: 'height-input',
    heightAddButton: 'height-add-button',
    heightItem: 'height-item',
    visionHeader: 'vision-header',
    visionLeftInput: 'vision-left-input',
    visionRightInput: 'vision-right-input',
    visionAddButton: 'vision-add-button',
    visionItem: 'vision-item',
    lastMenstrualPeriodHeader: 'last-menstrual-period-header',
    lastMenstrualPeriodDateInput: 'last-menstrual-period-date-input',
    lastMenstrualPeriodUnsureCheckbox: 'last-menstrual-period-unsure-checkbox',
    lastMenstrualPeriodAddButton: 'last-menstrual-period-add-button',
    lastMenstrualPeriodItem: 'last-menstrual-period-item',
    deleteIcon: 'DeleteOutlinedIcon',
    addNoteButton: 'add-vitals-note-button',
    pencilIconButton: 'EditOutlinedIcon',
    abnormalVitalIcon: 'WarningAmberOutlinedIcon',
  },
  visitDetailsPage: {
    cancelVisitButton: 'cancel-visit-button',
    cancelationReasonDropdown: 'cancelation-reason-dropdown',
    cancelVisitDialogue: 'cancel-visit-dialogue',
  },
  patientRecordPage: {
    seeAllPatientInfoButton: 'see-all-patient-info-button',
  },
  addInsuranceDialog: {
    id: 'add-insurance-dialog',
    type: 'add-insurance-dialog-type',
    insuranceCarrier: 'add-insurance-dialog-carrier',
    planType: 'add-insurance-dialog-plan-type',
    memberId: 'add-insurance-dialog-member-id',
    policyHoldersFirstName: 'add-insurance-dialog-policy-holders-first-name',
    policyHoldersLastName: 'add-insurance-dialog-policy-holders-last-name',
    policyHoldersMiddleName: 'add-insurance-dialog-policy-holders-middle-name',
    policyHoldersDateOfBirth: 'add-insurance-dialog-policy-holders-date-of-birth',
    policyHoldersSex: 'add-insurance-dialog-policy-holders-sex',
    streetAddress: 'add-insurance-dialog-street-address',
    addressLine2: 'add-insurance-dialog-address-line2',
    city: 'add-insurance-dialog-city',
    state: 'add-insurance-dialog-state',
    zip: 'add-insurance-dialog-zip',
    relationship: 'add-insurance-dialog-relationship',
    additionalInformation: 'add-insurance-dialog-additional-information',
    addInsuranceButton: 'add-insurance-dialog-add-insurance-button',
  },
  documentProcedurePage: {
    title: 'document-procedure-title',
    consentForProcedure: 'consent-for-procedure-checkbox',
    procedureType: 'procedure-type',
    cptCodeInput: 'cpt-code-input',
    cptCode: 'cpt-code',
    diagnosis: 'diagnosis',
    diagnosisItem: 'diagnosis-item',
    diagnosisDeleteButton: 'diagnosis-delete-button',
    performedBy: 'performed-by',
    anaesthesia: 'anaesthesia',
    site: 'site',
    sideOfBody: 'side-of-body',
    technique: 'technique',
    instruments: 'instruments',
    procedureDetails: 'procedure-details',
    specimenSent: 'specimen-sent',
    complications: 'complications',
    patientResponse: 'patient-response',
    postProcedureInstructions: 'post-procedure-instructions',
    timeSpent: 'time-spent',
    documentedBy: 'documented-by',
    saveButton: 'save-button',
  },
  proceduresPage: {
    title: 'procedures-title',
    cptCode: 'cpt-code',
    diagnosis: 'diagnosis',
    procedureType: 'procedure-type',
    documentedBy: 'documented-by',
    procedureRow: 'procedure-row',
  },
  nursingOrdersPage: {
    title: 'nursing-orders-title',
    loading: 'nursing-orders-loading-indicator',
    table: 'nursing-orders-table',
    orderButton: 'nursing-orders-order-button',
    orderRow: 'nursing-orders-row',
    orderNote: 'nursing-orders-row-note',
    status: 'nursing-orders-row-status',
    orderAddedDate: 'nursing-orders-row-date',
    deleteButton: 'nursing-orders-row-delete',
    emptyState: 'nursing-orders-empty-state',
  },
  nursingOrderCreatePage: {
    title: 'nursing-order-create-title',
    orderNoteInput: 'nursing-order-create-note-input',
    orderButton: 'nursing-order-create-order-button',
    cancelButton: 'nursing-order-create-cancel-button',
  },
  nursingOrderDetailsPage: {
    orderNote: 'nursing-order-details-note',
    status: 'nursing-order-details-status',
    historySection: 'nursing-order-details-history',
    historyToggleButton: 'nursing-order-details-history-toggle',
    completeOrderButton: 'nursing-order-details-complete-button',
    backButton: 'nursing-order-details-back-button',
    orderedBy: 'nursing-order-details-ordered-by',
    orderedDate: 'nursing-order-details-ordered-date',
  },
  radioButton: {
    checkedIcon: 'RadioButtonCheckedIcon',
  },
  inHouseLabsPage: {
    title: 'in-house-labs-title',
    orderButton: 'order-button',
    deleteButtonPrefix: 'delete-button-',
    tableRowPrefix: 'in-house-lab-table-row-',
    loading: 'in-house-labs-table-loading',
    noLabsMessage: 'in-house-labs-table-no-labs-text',
  },
  orderInHouseLabPage: {
    title: 'order-in-house-labs-title',
    orderInHouseLabButton: 'order-in-house-lab-button',
    orderAndPrintLabelButton: 'order-and-print-label-button',
    testTypeField: 'test-type',
    testTypeList: 'test-type-list',
    CPTCodeFieldPrefix: 'cpt-code-',
    diagnosis: 'diagnosis',
    additionalDx: 'additionalDx',
    notes: 'in-house-labs-notes',
    loading: 'in-house-lab-orders-loading',
    runAsRepeatBtnPrefix: 'repeat-btn-',
    error: 'order-in-house-lab-error',
  },
  collectSamplePage: {
    testName: 'test-name',
    status: 'order-status',
    source: 'source',
    collectedBy: 'collected-by',
    collectionDate: 'collection-date',
    collectionTime: 'collection-time',
    markCollectedButton: 'mark-collected-button',
  },
  performTestPage: {
    title: 'page-title',
    testName: 'test-name',
    status: 'order-status',
    testResult: (result?: string) => {
      const idPrefix = 'test-result';
      return result ? `${idPrefix}-${result.toLowerCase().replace(/\s+/g, '-')}` : idPrefix;
    },
    submitButton: 'submit-button',
    resultEntryTable: {
      numericPrefix: 'result-numeric-',
    },
  },
  resultPage: {
    testName: 'test-name',
    dateAndStatus: 'order-date-status',
    resultsPDF: 'results-pdf',
    diagnose: 'diagnose',
    repeatBtn: 'repeat-btn',
    resultCard: 'result-card',
    resultPageContainerPrefix: 'result-page-container-',
    reflexAlert: 'reflex-alert',
    orderReflexTestBtn: 'order-reflex-test-btn',
  },
  allergies: {
    allergiesPageTitle: 'allergies-title',
    knownAllergiesColumn: 'known-allergies-column',
    knownAllergiesList: 'known-allergies-list',
    knownAllergiesPatientProvidedList: 'known-allergies-patient-provided-list',
    knownAllergiesInput: 'known-allergies-input',
    knownAllergiesListItem: 'known-allergies-list-item',
    knownAllergiesListItemDeleteButton: 'known-allergies-list-item-delete-button',
  },
  medicalConditions: {
    medicalConditionsPageTitle: 'medical-conditions-title',
    medicalConditionColumn: 'medical-condition-column',
    medicalConditionsList: 'medical-condition-list',
    medicalConditionPatientProvidedList: 'medical-condition-patient-provided-list',
    medicalConditionsInput: 'medical-condition-input',
    medicalConditionListItem: 'medical-condition-list-item',
  },
  surgicalHistory: {
    surgicalHistoryTitle: 'surgical-history-title',
    surgicalHistoryOption: 'surgical-history-option',
    surgicalHistoryColumn: 'surgical-history-column',
    surgicalHistoryList: 'surgical-history-list',
    surgicalHistoryPatientProvidedList: 'surgical-history-patient-provided-list',
    surgicalHistoryInput: 'surgical-history-input',
    surgicalHistoryListItem: 'surgical-history-list-item',
  },
  orderVaccinePage: {
    title: 'order-vaccine-title',
    vaccine: 'order-vaccine-vaccine',
    dose: 'order-vaccine-dose',
    units: 'order-vaccine-units',
    route: 'order-vaccine-route',
    location: 'order-vaccine-location',
    instructions: 'order-vaccine-instructions',
    orderedBy: 'order-vaccine-ordered-by',
    orderVaccineButton: 'order-vaccine-button',
    associatedDx: 'order-vaccine-associated-dx',
    manufacturer: 'order-vaccine-manufacturer',
  },

  immunizationPage: {
    title: 'immunization-title',
    newOrderButton: 'new-order-button',
    marTableRowPrefix: 'mar-table-vaccine-',
    marTableRow: (vaccineId: string) => `mar-table-vaccine-${vaccineId}`,
    marTableVaccineCell: 'mar-table-vaccine-cell',
    marTableStatusCell: 'mar-table-status-cell',
    marTableDoseRouteCell: 'mar-table-dose-route-cell',
    marTableInstructionsCell: 'mar-table-instructions-cell',
    marTableOrderedDateCell: 'mar-table-ordered-date-cell',
    marTableOrderedPersonCell: 'mar-table-ordered-person-cell',
    marTableGivenDateCell: 'mar-table-given-date-cell',
    marTableGivenPersonCell: 'mar-table-given-person-cell',
    marTableReasonCell: 'mar-table-reason-cell',
    vaccineDetailsTab: 'vaccine-details-tab',
    marTab: 'immunization-mar-tab',
    pencilIconButton: 'EditOutlinedIcon',
    deleteButton: 'DeleteOutlinedIcon',
  },

  vaccineDetailsPage: {
    lotNumber: 'lot-number',
    expiredDate: 'expired-date',
    mvxCode: 'mvx-code',
    cvxCode: 'cvx-code',
    cptCode: 'cpt-code',
    ndcCode: 'ndc-code',
    administeredDate: 'administered-date',
    administeredTime: 'administered-time',
    visCheckbox: 'vis-checkbox',
    visGivenDate: 'vis-given-date',
    relationship: 'relationship',
    fullName: 'fullName',
    mobile: 'mobile',
    administeredButton: 'administered-button',
    partlyAdministeredButton: 'partly-administered-button',
    notAdministeredButton: 'not-administered-button',
  },

  administrationConfirmationDialog: {
    patient: 'administration-dialog-patient',
    vaccine: 'administration-dialog-vaccine',
    message: 'administration-dialog-message',
    reasonField: 'administration-dialog-reason-field',
  },

  inHouseMedicationAdministrationConfirmationDialog: {
    patient: 'administration-dialog-patient',
    medication: 'administration-dialog-medication',
    message: 'administration-dialog-message',
    reasonField: 'administration-dialog-reason-field',
  },

  screeningPage: {
    title: 'screening-title',
    asqQuestion: 'asq-question',
    screeningNoteField: 'screening-note-field',
    screeningNoteItem: 'screening-note-item',
    addNoteButton: 'add-screening-note-button',
    askPatientQuestion: 'ask-patient-question',
    vaccinationNoteField: 'vaccination-note-field',
    answerDropdown: 'answer-dropdown',
  },

  medicationsPage: {
    title: 'medications-title',
    medicationNoteField: 'medication-note-field',
    addNoteButton: 'add-medication-note-button',
    seeMoreButton: 'see-more-button',
    deleteIcon: 'DeleteOutlinedIcon',
    pencilIconButton: 'EditOutlinedIcon',
  },

  editNoteDialog: {
    cancelButton: 'edit-note-dialog-cancel-button',
    proceedButton: 'edit-note-dialog-proceed-button',
    title: 'edit-note-dialog-title',
    message: 'edit-note-dialog-message',
  },

  radiologyPage: {
    title: 'radiology-page-title',
    orderButton: 'radiology-order-button',
    submitOrderButton: 'radiology-submit-order-button',
    radiologyOrderRow: (serviceRequestId: string) => `radiology-order-row-${serviceRequestId}`,
    deleteOrderButton: (serviceRequestId: string) => `radiology-delete-order-${serviceRequestId}`,
  },

  commonLabOrder: {
    deleteDialog: 'delete-lab-order-dialog',
    deleteDialogButton: 'delete-lab-order-dialog-btn',
    labSets: {
      launchModal: 'launch-lab-set-modal-btn',
      selectionModal: 'lab-set-modal',
      selectionBtnPrefix: 'lab-set-select-btn',
    },
  },

  procedureCodes: {
    addButton: 'procedure-codes-add-button',
    searchInput: 'procedure-codes-search-input',
    downloadCsvButton: 'procedure-codes-download-csv-button',
    uploadCsvButton: 'procedure-codes-upload-csv-button',
    codeInput: 'procedure-codes-code-input',
    modifierInput: 'procedure-codes-modifier-input',
    amountInput: 'procedure-codes-amount-input',
    saveButton: 'procedure-codes-save-button',
    cancelButton: 'procedure-codes-cancel-button',
    uploadPreviewDialog: 'procedure-codes-upload-preview-dialog',
    importDeltaButton: 'procedure-codes-import-delta-button',
    replaceAllButton: 'procedure-codes-replace-all-button',
    codeRow: (code: string) => `procedure-code-row-${code}`,
    editButton: (code: string) => `procedure-code-edit-${code}`,
    deleteButton: (code: string) => `procedure-code-delete-${code}`,
  },

  globalTemplates: {
    admin: {
      scanForStaleBtn: 'global-template-scan-staleness-btn',
    },
  },

  reviewOfSystemsPage: {
    rosTableContainer: 'review-of-systems-table-container',
    rosTable: 'review-of-systems-table',
    deniesCheckboxCell: 'ros-denies-checkbox-cell',
    reportsCheckboxCell: 'ros-reports-checkbox-cell',
  },

  externalLabs: {
    labsStatusChip: 'labs-status-chip',
    labsBreadCrumbs: 'labs-bread-crumbs',
    patientRecordLabsTab: 'patient-record-labs-tab',
    labsTable: {
      patientChartExternalLabsPage: 'patient-chart-external-labs',
      patientRecordExternalLabsPage: 'patient-record-external-labs',
      addExternalLabBtn: 'add-external-lab-btn',
      bundleContainerPrefix: 'tables-table-bundle-container-',
      bundleHeaderRowTitlePrefix: 'labs-table-bundle-header-row-title-',
      bundleRowPrefix: 'labs-table-bundle-row-',
      bundleRowCellTestType: 'bundle-row-test-type',
      bundleRowDeleteBtn: 'bundle-row-delete-btn',
      bundleRowSubmitBtn: 'bundle-row-submit-btn',
    },
    createPg: {
      createExternalLabForm: 'create-external-lab-form',
      orderingOffice: 'external-lab-order-office-select',
      additionalDxSelect: 'external-lab-additional-dx-select',
      selectedDxContainer: 'selected-dx-container',
      paymentMethod: 'external-lab-payment-method',
      labsSearchAutoComplete: 'external-lab-search-autocomplete',
      selectedLabContainer: 'selected-external-labs-container',
      addClinicalInfoNote: 'add-clinical-info-note-btn',
      clinicalInfoNote: 'clinical-info-note',
      createExternalLabOrderBtn: 'create-external-lab-order-btn',
    },
    detailsPg: {
      pageContainer: 'externals-lab-detail-pg',
      aoeAnswers: 'external-lab-aoe-answers',
      requisitionNumber: 'external-lab-requisition-number',
      orderingOffice: 'external-lab-ordering-office',
      clinicalNote: 'external-lab-clinical-note',
      aoeTextEntryPrefix: 'external-lab-aoe-text-entry-',
      aoeRadioEntryPrefix: 'external-lab-radio-entry-',
      aoeSingleChoicePrefix: 'external-lab-single-choice-',
      aoeChoiceOptionPrefix: 'external-lab-choice-option-',
      aoeDecimalEntryPrefix: 'external-lab-decimal-entry-',
      samples: {
        card: 'external-lab-sample-collection-card',
        container: 'external-lab-sample-collection-card-container',
        volume: 'external-lab-sample-collection-card-volume',
        minVolume: 'external-lab-sample-collection-card-min-volume',
        storage: 'external-lab-sample-collection-card-storage',
        instructions: 'external-lab-sample-collection-card-instructions',
        collectionDate: 'external-lab-sample-collection-card-collection-date',
        collectionTime: 'external-lab-sample-collection-card-collection-time',
      },
      markReadyBtn: 'external-lab-mark-ready-btn',
    },
  },
};
